module.exports = __webpack_public_path__ + "2b333b2a7483e2fdcfedca523c963c74.png";